export default __webpack_public_path__ + "static/media/hero_card2.72aa7e02.jpg";